import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { toast } from 'react-toastify';

import { DeclarationCustomsFlowType } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  lrn: string;
  flow?: DeclarationCustomsFlowType;
}
export const useSendOneHv = () => {
  const queryClient = useQueryClient();

  const mutationFn = async ({ lrn, flow }: HookProps) => {
    await request({
      path: `idms/send-one-declaration`,
      method: 'POST',
      authenticate: true,
      dataObject: {
        LRN: lrn,
        flow,
      },
    });
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['declarations'] });
      queryClient.invalidateQueries({ queryKey: ['declaration-groups'] });
      queryClient.invalidateQueries({ queryKey: ['declaration-list'] });
      toast.success('Declaration sent successfully!');
    },
    onError: (error) => {
      const errorResponse = (error as AxiosError)?.response?.data;
      const errorMessage = errorResponse?.retryAfter
        ? `Error sending declaration! ${errorResponse?.error || ''} ${errorResponse?.message || ''}`
        : `Error sending declaration!`;
      showErrorToast(error, errorMessage);
    },
  });
};
